import { Link } from "react-router-dom";

const TermsPage = () => {
  const lastUpdated = "June 2026";

  return (
    <div className="bg-white" data-testid="terms-page">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-20">
        <p className="text-sm uppercase tracking-widest text-slate-500 mb-4">Legal</p>
        <h1
          className="text-4xl sm:text-5xl font-bold text-[#0A0A0A] mb-2"
          style={{ fontFamily: "Barlow Condensed, sans-serif" }}
        >
          Terms of Service
        </h1>
        <p className="text-sm text-slate-500 mb-12">Last updated: {lastUpdated}</p>

        <div className="prose prose-slate max-w-none space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">1. Introduction</h2>
            <p>
              These Terms of Service ("Terms") govern your use of the website and services provided
              by Order &amp; Clean Co (ABN <strong>73 677 568 884</strong>), an Australian-registered
              business operating in Sydney, NSW. By booking a service, requesting a quote or using
              this website you agree to be bound by these Terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">2. Services we provide</h2>
            <p>
              We offer residential garage cleanout, organisation and space enhancement services
              including but not limited to garage clear-outs, garage resets, flooring installation,
              ceramic coatings, storage systems, lighting upgrades and home network installations.
              Specific scope, inclusions and exclusions are described on our website or in any quote
              we provide.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">3. Quotes and pricing</h2>
            <p>
              Estimated quotes generated on our website are indicative only and are based on the
              information you provide. The final price may be adjusted after on-site assessment if the
              scope, condition or volume of items differs materially from what was disclosed at the
              time of booking. We will discuss and confirm any change with you before proceeding.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">4. Deposit and payment</h2>
            <p>
              A non-refundable deposit of $100 AUD is required to secure your booking. The deposit is
              applied against the final invoice. The remaining balance is due on the day of service
              completion via the payment method agreed at the time of booking. All payments are
              processed securely by Stripe Payments Australia Pty Ltd.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">5. Cancellations and rescheduling</h2>
            <p>
              You may reschedule your booking at no cost provided you give at least 48 hours' notice.
              Cancellations made with less than 48 hours' notice will forfeit the $100 deposit. If we
              need to cancel or reschedule due to weather, illness or other unforeseen events we will
              offer you the next available date or a full refund of the deposit.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">6. Your responsibilities</h2>
            <ul className="list-disc ml-6 space-y-2 mt-3">
              <li>Provide accurate information about your garage and the items inside it;</li>
              <li>Ensure a person aged 18 or over is present at the start of the appointment;</li>
              <li>Remove or secure any valuables, sensitive documents or hazardous materials in advance;</li>
              <li>Provide reasonable access to the property, water and a power outlet where needed;</li>
              <li>Notify us in writing of any items you do not want discarded before the appointment.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">7. Items removed from your property</h2>
            <p>
              Items you ask us to discard, donate or recycle become our responsibility once removed
              from the property and we will dispose of them lawfully. We are not liable for items
              discarded on your instruction or for items left unsecured that we reasonably believed
              were intended for removal.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">8. Liability</h2>
            <p>
              We carry public liability insurance and will perform our services with reasonable care
              and skill. To the maximum extent permitted by Australian Consumer Law our liability for
              any claim arising from the services is limited to re-supplying the service or refunding
              the amount you paid for the affected service. Nothing in these Terms excludes any
              consumer guarantee or right you have under the Australian Consumer Law.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">9. Space enhancement partners</h2>
            <p>
              Some enhancement services (flooring, coatings, electrical, networking) may be performed
              by qualified third-party installers we engage on your behalf. We will tell you when this
              is the case. Where work is performed by a licensed third party, statutory warranties on
              that work are provided by that installer in line with their licence and trade
              obligations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">10. Photos and case studies</h2>
            <p>
              We may take before and after photos for our records. We will not use identifiable photos
              of your home publicly without your permission.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">11. Governing law</h2>
            <p>
              These Terms are governed by the laws of New South Wales, Australia. Any dispute will be
              dealt with in the courts of New South Wales unless we both agree otherwise.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-[#1a365d] mb-3">12. Contact</h2>
            <p>
              Order &amp; Clean Co<br />
              ABN 73 677 568 884<br />
              Sydney, NSW, Australia<br />
              <a href="mailto:hello@orderandcleanco.com.au" className="text-[#1a365d] underline">
                hello@orderandcleanco.com.au
              </a>
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-slate-200">
          <Link
            to="/"
            className="text-[#1a365d] font-semibold hover:underline"
            data-testid="terms-back-home"
          >
            ← Back to home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
